{/* Auto-generated icon - do not edit */}
import React from 'react'

interface FlagIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const FlagIcon = React.forwardRef<SVGSVGElement, FlagIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 156 153"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M12.0609 95.1263C12.0609 96.6945 12.0609 97.9957 12.0609 99.2962C12.0942 114.808 12.1224 130.32 12.1453 145.833C12.1598 146.936 12.0344 148.038 11.7723 149.111C11.1536 151.485 9.6659 152.694 7.60875 152.701C5.55159 152.707 3.9633 151.469 3.41139 149.159C3.11438 147.754 2.96228 146.323 2.95745 144.888C2.04301 111.545 1.94439 78.1984 2.20964 44.8448C2.31017 32.2229 1.70766 19.5959 1.38599 6.97208C1.30427 3.77205 2.45414 2.1805 5.8609 1.4732C12.606 0.0364486 19.566 -0.0776449 26.3546 1.13733C35.4163 2.70302 44.24 5.42344 52.6099 9.23168C62.1836 13.657 72.0454 17.1649 82.5536 18.835C98.6327 21.3919 114.371 19.9721 129.988 15.7445C135.543 14.2411 141.189 13.0617 146.822 11.8714C148.122 11.6788 149.447 11.7255 150.732 12.0094C151.625 12.1312 152.447 12.5624 153.055 13.2278C153.663 13.8933 154.018 14.7508 154.059 15.6511C154.361 18.1749 154.694 20.711 154.743 23.2471C154.983 35.7633 155.359 48.2833 155.251 60.7982C155.144 73.1999 154.572 85.6007 154.084 97.9976C153.906 102.529 151.714 105.849 147.137 107.021C140.383 108.75 133.614 110.435 126.799 111.899C111.799 115.118 96.7902 113.969 81.8162 111.602C70.0719 109.746 58.7503 106.351 47.6221 102.202C37.5199 98.4359 27.1283 95.7875 16.3081 95.1353C15.013 95.0588 13.7121 95.1263 12.0609 95.1263ZM146.864 22.5393C146.476 22.5577 146.091 22.5995 145.709 22.6644C142.096 23.7146 138.49 24.7927 134.872 25.8274C114.65 31.6109 94.32 32.6763 73.7795 27.4795C65.1293 25.2908 57.0252 21.7742 49.0515 17.9265C40.752 13.9664 31.9293 11.2119 22.8506 9.74572C18.9324 9.12588 14.9472 9.05068 11.0083 9.52258C11.0083 13.9311 10.9124 18.0103 11.0265 22.081C11.3307 32.9297 11.8521 43.7737 12.0441 54.6257C12.2108 64.0391 12.044 73.458 12.0259 82.8746C12.0259 84.0532 12.0259 85.2312 12.0259 86.6348C13.5447 86.6348 14.6304 86.6017 15.7134 86.6413C18.5929 86.7469 21.4907 86.7119 24.3462 87.0393C34.0787 88.1557 43.3833 90.9577 52.5977 94.207C79.3667 103.648 106.579 107.266 134.536 99.9192C138.25 98.9435 141.95 97.9166 145.661 96.9117C147.093 71.9254 145.902 47.3551 146.861 22.5393H146.864Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="155" height="153" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

FlagIcon.displayName = 'FlagIcon'
